export const myVipConstant = {
    CHECK_VIP_TAD_IS_ENABLED: 'CHECK_VIP_TAD_IS_ENABLED',
    UPDATE_VIP_LEVEL_INFO: 'UPDATE_VIP_LEVEL_INFO',
    UPDATE_HAS_PENDING_CLAIM: 'UPDATE_HAS_PENDING_CLAIM',
    UPDATE_VIP_BONUS_INFO: 'UPDATE_VIP_BONUS_INFO',
    SET_FETCH_VIP_BONUS_INFO_STATUS: 'SET_FETCH_VIP_BONUS_INFO_STATUS',
    SET_FETCH_VIP_PROGRESS_STATUS: 'SET_FETCH_VIP_PROGRESS_STATUS',
    SET_VIP_PROGRESS: 'SET_VIP_PROGRESS',
};
